import { Shark, Utils } from "shark-mvc";
// import moment from "moment-timezone";

import NousCoreModel from "./NousCoreModel";
import OrganizationMembership from "./OrganizationMembership";

class Organization extends NousCoreModel {
	activityColor = ""; // Join Field
	description = "";
	name = "";
	settings = {
		membersLimit: 0, // 0 means no limit 
	}
	ownerGuid = "";
	userList = [];

	__cssClasses = new Set();
	__cssClassesString = "";
	__currUserCanEdit = false;
	__currUserCanManageUsers = false;
	__currUserIsOwner = false;
	__ownerName = "";
	__selected = false;
		
	constructor (data) {
		super(data, "Organization");
		
		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.settings = this.exportObjectField("settings");
		exportData.userList = this.exportArrayField("userList");
				
		return exportData;
	}

	// Dave: Ma se questa cosa diventasse una roba standard del "renderer"??
	flattenCSSClasses () {
		this.__cssClassesString = "";
		this.__cssClasses.forEach(item => this.__cssClassesString += " " + item);
	}

	import (data, options) {
		super.import(data, options);

		this.parseOwner();
		this.flattenCSSClasses();
		this.parseUserOrganizationPermissions();
	}

	// onActivityColorChanged () {
	// 	Shark.render();
	// }

	parseOwner () {
		const owner = Utils.safp(Shark.$store.userList, "guid", this.ownerGuid);

		if (owner) {
			this.__ownerName = owner.__fullName;
			this.__ownerUser = owner;
		}

		this.__currUserIsOwner = this.ownerGuid === Shark.$store.currUser.guid;
		this.__currUserCanEdit = this.ownerGuid === Shark.$store.currUser.guid;
		//this.__currUserCanManageUsers = this.ownerGuid === Shark.$store.currUser.guid;
	}

	parseUserOrganizationPermissions () {
		if (Shark.$store.organizationMembershipList) {
			const organizationMembership = Shark.$store.organizationMembershipList.find(item => item.organizationGuid === this.guid);
			
			if (organizationMembership) {
				this.__currUserCanSeeInviteLimit = [OrganizationMembership.ROLE_OWNER].includes(organizationMembership.role) ? true : false;
				this.__currUserCanManageUsers = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(organizationMembership.role) ? true : false;
			}
		}
	}
}

Shark.registerModel("Organization", Organization);

export default Organization;
